export default __webpack_public_path__ + "static/media/longlogo.9c7e110d.svg";